import React from 'react';
import { Box, Button, Typography, Stack } from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { API_BASE_URL } from '../config';
import { clearAuthToken } from '../utils/authToken';
import LandingImage from '../assets/Image.png';

const LoginPage: React.FC = () => {
  const handleLogin = () => {
    clearAuthToken();
    window.location.href = `${API_BASE_URL}/auth/login`;
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgb(250, 250, 244)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 1320,
          position: 'relative',
          px: { xs: 4, sm: 6, md: 10 },
          mx: 'auto',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1.2fr 1fr' },
            columnGap: { xs: 6, md: 12 },
            rowGap: { xs: 4, md: 8 },
            alignItems: 'center',
            pt: { xs: 6, md: 0 },
          }}
        >
        <Box
          sx={{
            height: { xs: '50vh', md: '78vh' },
            display: 'flex',
            width: '100%',
            px: { xs: 1.5, md: 2 },
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          <img
            src={LandingImage}
            alt="Landing"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            pr: { md: 4 },
            minWidth: 0,
          }}
        >
          <Box
            component="svg"
            xmlns="http://www.w3.org/2000/svg"
            width="96"
            height="30"
            viewBox="0 0 96 30"
            fill="none"
            sx={{
              width: { xs: 96, md: 110 },
              height: 'auto',
              maxWidth: '100%',
              alignSelf: 'flex-start',
            }}
          >
            <path
              d="M13.2606 7.2394C11.9318 6.46326 10.4368 6.06982 8.81832 6.06982C6.31285 6.06982 4.1883 6.92465 2.50368 8.60748C0.842309 10.2921 0 12.4041 0 14.8881C0 17.3721 0.842309 19.4842 2.50547 21.1688C4.19009 22.8534 6.31464 23.7065 8.81832 23.7065C10.4368 23.7065 11.9318 23.313 13.2606 22.5369C14.5392 21.7697 15.555 20.7521 16.2811 19.5146C16.2918 19.4949 16.2954 19.4734 16.29 19.452C16.2846 19.4305 16.2703 19.4109 16.2507 19.4001L12.7831 17.4204C12.7634 17.4079 12.7384 17.4061 12.7169 17.4115C12.6919 17.4186 12.6722 17.4347 12.6579 17.458C12.3145 18.0893 11.8102 18.6007 11.1575 18.9781C10.4725 19.3679 9.67314 19.5629 8.78434 19.5629C7.46096 19.5629 6.3504 19.1229 5.48127 18.2556C4.61213 17.365 4.17399 16.2312 4.17399 14.8846C4.17399 13.5379 4.61392 12.3827 5.48127 11.5135C6.34861 10.6229 7.46096 10.1705 8.78434 10.1705C9.65168 10.1705 10.4386 10.3779 11.1253 10.791C11.7762 11.1684 12.2805 11.6799 12.6239 12.3093C12.6364 12.3326 12.6579 12.3505 12.6829 12.3558C12.7062 12.3612 12.7312 12.3594 12.7509 12.3469L16.1899 10.3332C16.2292 10.31 16.2435 10.2617 16.2221 10.2224C15.5389 8.98303 14.5428 7.97799 13.2641 7.23225L13.2606 7.2394Z"
              fill="#C90C61"
            />
            <path
              d="M21.5709 21.5908C21.68 21.5479 21.8016 21.5765 21.8785 21.6606C23.1143 23.0179 24.8203 23.7065 26.952 23.7065C29.1875 23.7065 31.1189 22.8534 32.6908 21.1706C34.286 19.4645 35.0962 17.3507 35.0962 14.8881C35.0962 12.4256 34.286 10.3243 32.6908 8.63967C31.1171 6.93359 29.1875 6.06982 26.952 6.06982C24.7166 6.06982 23.1143 6.75833 21.8785 8.11569C21.8016 8.20153 21.68 8.22835 21.5709 8.18543C21.4636 8.1443 21.3975 8.04773 21.3975 7.93507V6.62779C21.3975 6.5795 21.3599 6.54195 21.3116 6.54195H17.3075C17.2592 6.54195 17.2217 6.5795 17.2217 6.62779V29.8995C17.2217 29.9478 17.2592 29.9853 17.3075 29.9853H21.3116C21.3599 29.9853 21.3975 29.9478 21.3975 29.8995V21.843C21.3975 21.7303 21.4636 21.6356 21.5709 21.5926V21.5908ZM22.7369 11.417C23.6275 10.5049 24.7721 10.0417 26.1401 10.0417C27.5082 10.0417 28.6546 10.5049 29.5451 11.4188C30.4572 12.3076 30.9204 13.4771 30.9204 14.8899C30.9204 16.3027 30.4572 17.4812 29.5451 18.3951C28.6331 19.3071 27.5082 19.7381 26.1419 19.7381C24.7756 19.7381 23.6275 19.2875 22.7387 18.3951C21.8481 17.4812 21.3975 16.3027 21.3975 14.8899C21.3975 13.4771 21.8481 12.3093 22.7405 11.4188L22.7369 11.417Z"
              fill="black"
            />
            <path
              d="M42.1043 11.9479C43.1237 11.2773 44.2807 10.993 45.5433 11.1021C45.5701 11.1038 45.5952 11.0967 45.613 11.0788C45.6309 11.0627 45.6417 11.0395 45.6417 11.0144V6.52568C45.6417 6.50244 45.6327 6.48098 45.6166 6.46488C45.6005 6.44879 45.5791 6.43984 45.5576 6.44163C44.4989 6.46667 43.5153 6.73492 42.6355 7.23745C41.997 7.61121 41.4766 8.12625 41.0939 8.76648C41.0242 8.88272 40.8811 8.93101 40.7344 8.89166C40.6003 8.85411 40.5127 8.75038 40.5127 8.62699V6.86368C40.5127 6.8154 40.4751 6.77784 40.4269 6.77784H36.4228C36.3745 6.77784 36.3369 6.8154 36.3369 6.86368V23.1483C36.3369 23.1966 36.3745 23.2342 36.4228 23.2342H40.4269C40.4751 23.2342 40.5127 23.1966 40.5127 23.1483V15.4978C40.5127 13.8543 41.0474 12.6597 42.1043 11.9479Z"
              fill="black"
            />
            <path
              d="M49.3157 4.63538C50.5958 4.63538 51.6334 3.59772 51.6334 2.31769C51.6334 1.03767 50.5958 0 49.3157 0C48.0357 0 46.998 1.03767 46.998 2.31769C46.998 3.59772 48.0357 4.63538 49.3157 4.63538Z"
              fill="black"
            />
            <path
              d="M47.2567 6.5415H51.2608C51.3091 6.5415 51.3467 6.57906 51.3467 6.62734V23.1498C51.3467 23.1981 51.3091 23.2357 51.2608 23.2357H47.2567C47.2085 23.2357 47.1709 23.1981 47.1709 23.1498V6.62734C47.1709 6.57906 47.2085 6.5415 47.2567 6.5415Z"
              fill="black"
            />
            <path
              d="M73.5647 23.2361H77.5688C77.6171 23.2361 77.6547 23.1986 77.6547 23.1503V12.9317C77.6547 10.8501 77.0735 9.16723 75.9235 7.93149C74.7987 6.69574 73.2661 6.06982 71.3669 6.06982C69.2799 6.06982 67.6668 6.80304 66.5687 8.24624C66.5151 8.31598 66.431 8.35533 66.3416 8.35533C66.2522 8.35354 66.1699 8.30704 66.1199 8.23551C65.1506 6.79947 63.6806 6.06982 61.7492 6.06982C59.8177 6.06982 58.4586 6.66534 57.4714 7.84028C57.3945 7.93149 57.2694 7.96368 57.1531 7.92076C57.0422 7.87963 56.9707 7.77948 56.9707 7.66681V6.626C56.9707 6.57771 56.9331 6.54016 56.8849 6.54016H52.8808C52.8325 6.54016 52.7949 6.57771 52.7949 6.626V23.1485C52.7949 23.1968 52.8325 23.2343 52.8808 23.2343H56.8849C56.9331 23.2343 56.9707 23.1968 56.9707 23.1485V13.842C56.9707 12.5883 57.2622 11.6155 57.8363 10.9484C58.4371 10.2778 59.2437 9.9398 60.2326 9.9398C61.1554 9.9398 61.8815 10.2331 62.3912 10.8125C62.8991 11.3884 63.1548 12.2038 63.1548 13.2339V23.1485C63.1548 23.1968 63.1923 23.2343 63.2406 23.2343H67.2447C67.293 23.2343 67.3306 23.1968 67.3306 23.1485V13.842C67.3306 12.5883 67.6095 11.6173 68.1621 10.952C68.7398 10.2814 69.5481 9.94158 70.5585 9.94158C71.4813 9.94158 72.2074 10.2349 72.7171 10.8143C73.2249 11.3919 73.4807 12.2056 73.4807 13.2357V23.1503C73.4807 23.1986 73.5182 23.2361 73.5665 23.2361H73.5647Z"
              fill="black"
            />
            <path
              d="M93.5965 8.60569C92.0245 6.92286 89.9912 6.06982 87.5537 6.06982C84.982 6.06982 82.845 6.92286 81.2068 8.60748C79.5669 10.2706 78.7354 12.3827 78.7354 14.8881C78.7354 17.3936 79.5777 19.5396 81.239 21.2028C82.9004 22.8641 85.1394 23.7082 87.8899 23.7082C91.0141 23.7082 93.4284 22.5583 95.0647 20.2907C95.079 20.271 95.0844 20.2496 95.0772 20.2246C95.0719 20.2013 95.0575 20.1816 95.0361 20.1691L91.8242 18.3164C91.7867 18.2949 91.7384 18.3039 91.7098 18.3396C90.8442 19.4019 89.5799 19.9384 87.956 19.9384C85.4291 19.9384 83.8214 18.9244 83.1794 16.9251C83.1543 16.8464 83.1669 16.7623 83.2169 16.6962C83.2652 16.6282 83.3457 16.5889 83.428 16.5889H95.7729C95.814 16.5889 95.8498 16.5585 95.8569 16.5191C95.9517 15.9486 96 15.4014 96 14.8899C96 12.4059 95.1899 10.2921 93.5947 8.60748L93.5965 8.60569ZM91.7276 13.2911C91.6776 13.3555 91.6025 13.3931 91.5202 13.3931H83.3511C83.2688 13.3931 83.1919 13.3555 83.1436 13.2911C83.0953 13.2268 83.0774 13.1463 83.0989 13.0694C83.3672 12.0787 83.8697 11.2918 84.5957 10.7374C85.3719 10.1204 86.3662 9.80746 87.5519 9.80746C88.5569 9.80746 89.46 10.0972 90.2362 10.6677C90.9891 11.2042 91.5041 12.0143 91.7724 13.0712C91.792 13.1481 91.7741 13.2303 91.7259 13.2929L91.7276 13.2911Z"
              fill="black"
            />
          </Box>
          <Typography
            variant="h3"
            sx={{
              color: '#1f2937',
              fontWeight: 300,
              lineHeight: 1.1,
              letterSpacing: '0.025em',
              fontSize: { xs: '2.6rem', md: '3.4rem' },
              fontFamily: '"Playfair Display", Georgia, serif',
            }}
          >
            Sales Intelligence Platform
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              fontSize: '1.05rem',
              lineHeight: 1.6,
              maxWidth: 520,
            }}
          >
            Sync meetings, run research, and launch proposals from one workspace built for pursuit teams.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="flex-start">
            <Button
              variant="contained"
              size="large"
              startIcon={<LoginIcon />}
              onClick={handleLogin}
              sx={{
                px: 4,
                py: 1.5,
                fontWeight: 700,
                fontSize: '1rem',
                textTransform: 'none',
                borderRadius: 0,
                background: 'linear-gradient(135deg, #C90C61 0%, #731A42 100%)',
                boxShadow: '0 18px 40px rgba(201, 12, 97, 0.25)',
                '&:hover': {
                  boxShadow: '0 20px 50px rgba(201, 12, 97, 0.35)',
                },
              }}
            >
              Login
            </Button>
          </Stack>
        </Box>
      </Box>
      </Box>
    </Box>
  );
};

export default LoginPage;
